import React, { useEffect, useId, useState } from "react";
import tampuuriWindowObject from "../../tampuuriWindowObject.js";
import accessibility from "../../accessibility.js";
import useHelpers from "../hooks/useHelpers.jsx";

function SelectExtras(props) {
  const { params, submitParams, svgObjects } = props;
  const [extraInfos, setExtraInfos] = useState({});
  const [state, setState] = useState({});
  const { translate, translatei18nDB, getExtraInfos } = tampuuriWindowObject();
  const { announceMessage, globalAccessibilitySpeakerId } = accessibility();
  const { id } = useId();
  const { checkForChecked } = useHelpers();

  useEffect(() => {
    setState({ loading: true });
    const extraData = getExtraInfos();
    setExtraInfos(extraData);
    setState({ loading: false });
  }, []);

  const addExtraInfo = (value) => {
    let currentExtraInfos = [...params.extraInfos];
    let accessibilitySpeakerLabel = "";

    if (checkForChecked(value, currentExtraInfos)) {
      currentExtraInfos = currentExtraInfos.filter((e) => e !== value);
      accessibilitySpeakerLabel =
        translate("Remove") + " " + translatei18nDB(value);
    } else {
      currentExtraInfos.push(value);
      accessibilitySpeakerLabel =
        translate("Add") + " " + translatei18nDB(value);
    }

    submitParams({ extraInfos: currentExtraInfos });
    announceMessage(globalAccessibilitySpeakerId, accessibilitySpeakerLabel);
  };

  if (state?.loading) {
    return;
  }

  return (
    <div className="extras" role="group" aria-labelledby={id}>
      <legend id={id}>{translate("Tarkenna hakua")}</legend>
      <div className="filter-buttons-container">
        {Object.entries(extraInfos).map(([key, value], index) => {
          return (
            <button
              className={
                checkForChecked(value, params?.extraInfos) ? "active" : ""
              }
              key={"first_" + value + index}
              onClick={(e) => {
                e.preventDefault();
                addExtraInfo(value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  addExtraInfo(value);
                }
              }}
            >
              {translatei18nDB(value)}{" "}
              {checkForChecked(value, params?.extraInfos) ? (
                <>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: svgObjects?.close,
                    }}
                  />
                  <span className="sr-only">{translate("Selected")}</span>
                </>
              ) : (
                <>
                  <span aria-hidden="true">+</span>
                </>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default SelectExtras;
